import type { FaireProductEntity } from "../../entity_types/product";

export const default_6: FaireProductEntity = {
  token: "default-6",
  type: "product",
  name: "Raw Honey Jar - 12oz",
  brandName: "Wildflower Honey",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/700a581cb33a5b4462bea91d0e3b42c62a8306d3b2242f876d8b455f24c9a53c.webp",
  priceDollars: 14.99,
  msrpDollars: 24,
  freeShipping: true,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
